/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-block[_ngcontent-%COMP%]{position:relative;display:inline-block;vertical-align:middle;margin-right:1em;width:45px;height:30px}.card-overlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;opacity:.7;display:none}.card-overlay-show[_ngcontent-%COMP%]{display:block!important}"];
export { styles as styles };
